<template>
	<div ref="idListPan" style="border:0px solid red; height:100%; display:grid; grid-template-rows:350px 1fr;">
		<div style="border:0px solid red;">
			<div class="SiftPanel" style="border:0px solid #bbbbbb;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:20px;">设备编码</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="hdCode">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:100px;">销售</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="dfPayChannel">
			</div>

			<div class="SiftPanel" style="border:0px solid #bbbbbb;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:20px;">客户名称</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="custName">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:100px;">订单号</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="dfCertificate">
			</div>

			<div class="SiftPanel" style="border:0px solid #bbbbbb;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:20px;">账号</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="userAcct">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:100px;">时长(月)</div>
				<input type="text" style="width:240px;" maxlength="4" v-model="dfBuyMonths">
			</div>

			<div class="SiftPanel" style="border:0px solid #bbbbbb;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:20px;">密码</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="newPwd1">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:100px;">授权码</div>
				<input type="text" style="width:240px;" maxlength="6" v-model="dfAuthCode">
			</div>

			<div class="SiftPanel" style="border:0px solid #bbbbbb;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:120px;  margin-top:-1px; margin-left:20px;">设备型号</div>
				<input type="text" style="width:240px;" maxlength="40" v-model="devSerialno">
			</div>

			<div style="float:left; width:400px; border:0px solid red; margin-top:20px;">
				<div class="NButton DIVNoSelect" style="width:120px; height:36px; float:left; margin-left:200px;" @click="onCustCheck">确定</div>
			</div>
		</div>

		<div style="float:left; width:100%; line-height:30px; border:1px solid #cccccc; padding-left:10px; overflow-y:scroll;" ref="idNote"></div>

	</div>
</template>

<script>

export default {
	name: 'custList',
	components:{

	},
	data () {
		return {
			custName: "",
			userAcct: "",
			newPwd1: "",
			hdCode: "",
			sCont: "",
			devId: "",
			dfPayChannel: "",
			dfCertificate: "",
			dfBuyMonths: "",
			dfAuthCode: "",
			custId: "",
			dfId: "",
			devSerialno: "",
			curDev: null
		}
	},
	mounted: function(){
		//this.userName = this.login.userName;
		//this.userAcct = this.login.userAcct;
	},
	computed:{

	},
	methods:{
		setNote: function( s, clr ){
			if( clr==1 ) this.sCont = "";
			if( this.sCont!="" ) this.sCont = this.sCont + "<br>";
			if( s!="" ) this.sCont = this.sCont + s;
			this.$refs["idNote"].innerHTML = this.sCont;
		},
		onCustCheck: function(){
			this.setNote( "", 1 );

			if( this.hdCode.trim()=="" )        {  alert( "请输入设备编码") ;     return;   }
			if( this.custName.trim()=="" )      {  alert( "请输入客户名称") ;     return;   }
			if( this.userAcct.trim()=="" )      {  alert( "请输入管理员账号") ;   return;   }
			if( this.newPwd1.trim()=="" )       {  alert( "请输入管理员密码") ;   return;   }
			if( this.dfPayChannel.trim()=="" )  {  alert( "请输入销售姓名") ;     return;   }
			if( this.dfCertificate.trim()=="" ) {  alert( "请输入订单号") ;       return;   }
			if( this.dfBuyMonths.trim()=="" )   {  alert( "请输入时长(月)") ;     return;   }
			if( this.dfAuthCode.trim()=="" )    {  alert( "请输入授权码") ;       return;   }
			if( this.devSerialno.trim()=="" )   {  alert( "请输入设备型号") ;     return;   }

			let body={custName: this.custName};
			this.doTrade( "POST", ServAddr+"/api/pub/custNameQry", this.onCustCheckOK, true, body, null );
		},
		onCustCheckOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				if( data.body.custId != null )
				{
					this.setNote( "<font style='color:red;'>Error: 客户已存在[ "+data.body.custId+" ]</font>", 0 );
					return;
				}
				this.onUserCheck();    // 执行用户账号检查
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: "+data.msg+"</font>", 0 );
			}
		},
		onUserCheck: function(){
			let body={userAcct: this.userAcct};
			this.doTrade( "POST", ServAddr+"/api/pub/userAcctQry", this.onUserCheckOK, true, body, null );
		},
		onUserCheckOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				if( data.body.userId != null )
				{
					this.setNote( "<font style='color:red;'>Error: 用户已存在[ "+data.body.userId+" ]</font>", 0 );
					return;
				}
				this.onDeviceCheck();    // 执行设备检查
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: "+data.msg+"</font>", 0 );
			}
		},
		onDeviceCheck: function(){
			let body={ pageSize:100, curPage:0, devName: "", devEquityLevel: 132, devHdcode: this.hdCode, custIds:"1000000,10000001" };

			this.doTrade( "POST", ServAddr+"/api/device/devList", this.onDeviceCheckOK, true, body, null );
			//this.doTrade( "POST", ServAddr+"/device/devListByCust", this.onDeviceCheckOK, true, body, null );
		},
		onDeviceCheckOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				if( data.body.devList.length==0 )   // 设备不存在
				{
					this.setNote( "<font style='color:red;'>Error: 设备不存在</font>", 0 );
				}
				else
				{
					for( let i=0; i<data.body.devList.length; i++ )
					{
						let s="custId="+data.body.devList[i].devCustId+" , "+
									"devHdcode="+data.body.devList[i].devHdcode+" , "+
									"custName="+data.body.devList[i].devCustName+" , "+
									"devId="+data.body.devList[i].devId+" , "+
									"devOs="+data.body.devList[i].devOs+" , "+
									"devValidate="+data.body.devList[i].devValidate;
						this.setNote( s, 0 );
					}
					if( 1 < data.body.devList.length )
					{
						this.setNote( "<font style='color:red;'>Error: 存在重复设备</font>", 0 );
					}
					else
					{
						this.curDev = data.body.devList[0];
						this.devId = data.body.devList[0].devId;

						this.onAddCust();
					}
				}
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: "+data.msg+"</font>", 0 );
			}
		},
		// 添加客户账号
		onAddCust: function(){
			let body={ custName:this.custName, userName:"admin", userAcct: this.userAcct, userNewPswd: this.newPwd1 };

			this.doTrade( "POST", ServAddr+"/api/cust/addCust", this.onAddCustOK, true, body, null );
		},
		onAddCustOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				if( data.body.custId && data.body.userId )
				{
					this.custId = data.body.custId;
					this.setNote( "<font style='color:green;'>添加客户[ "+this.custId+" ]成功</font>", 0 );
					this.setNote( "<font style='color:green;'>添加用户[ "+data.body.userId+" ]成功</font>", 0 );
					this.onDevModify();
				}
				else
				{
					if( !data.body.custId )
						 this.setNote( "<font style='color:red;'>Error: 添加客户失败</font>", 0 );
					else this.setNote( "<font style='color:red;'>Error: 添加用户失败</font>", 0 );
				}
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: 添加客户失败[ "+data.msg+" ]</font>", 0 );
			}
		},
		// 修改设备信息
		onDevModify: function(){
			let body={  devId:              this.devId,
						devEquityLevel:     this.curDev.devEquityLevel,
						devSerialno:        this.devSerialno,
						devAuthType:        110/*parseInt(this.devAuthType)*/,
						devSts:             this.curDev.devSts,
						deviceLock:         this.curDev.deviceLock,
						deviceMode:         this.curDev.deviceMode,
						devLocate:          this.curDev.devLocate,
						devValidate:        this.curDev.devValidate,
						devName:            "device"
					};
			this.doTrade( "POST", ServAddr+"/api/device/devEdit", this.onDevModifyOK, true, body, null );
		},
		onDevModifyOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				this.setNote( "<font style='color:green;'>修改设备[ "+this.devId+" ]成功</font>", 0 );

				this.onDevDevo();
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: 修改设备失败[ "+data.msg+" ]</font>", 0 );
			}
		},
		// 移交设备到客户
		onDevDevo: function(){
			if( this.custId == null || parseInt(this.custId)==0 ) return;

			let body={ devId: parseInt(this.devId), devCustId: parseInt(this.custId),  };
			this.doTrade( "POST", ServAddr+"/api/device/devDevo", this.onDevDevoOK, true, body, null );
		},
		onDevDevoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				this.setNote( "<font style='color:green;'>移交设备[ "+this.devId+" ]到客户[ "+this.custId+" ]成功</font>", 0 );

				this.onRenew();
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: 移交设备失败[ "+data.msg+" ]</font>", 0 );
			}
		},
		// 添加续费记录
		onRenew: function(){
			let body={	devId: this.devId,
						dfPayChannel: this.dfPayChannel,         // 支付通道-填销售姓名
						dfPayAccount: "***",                     // 付款账号
						dfPayAmount:  "9900",                    // 付款金额
						dfPayCurrency: 840,                      // 付款货币代码
						dfPayDate: this.getDateInt(),            // 付款日期
						dfColAccount: "***",                     // 收款账号
						dfCertificate: this.dfCertificate,       // 订单号
						dfBuyMonths: parseInt( this.dfBuyMonths)
				 };
			this.doTrade( "POST", ServAddr+"/api/fee/devFeeNew", this.onRenewOK, true, body, null );
		},
		onRenewOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				this.dfId = data.body.recId;
				this.setNote( "<font style='color:green;'>添加续费记录[ "+data.body.recId+" ]成功</font>", 0 );

				this.onDoRenew();
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: 添加续费记录失败[ "+data.msg+" ]</font>", 0 );
			}
		},
		// 执行续费
		onDoRenew: function(){
			let body={ dfId: this.dfId, devoCode:this.dfAuthCode };

			this.doTrade( "POST", ServAddr+"/api/fee/devFeeApply", this.onDoRenewOK, true, body, null );
		},
		onDoRenewOK: function(res){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
			{
				this.setNote( "<font style='color:green;'>续费[ "+this.dfId+" ]成功</font>", 0 );
				this.hdCode = "";
			}
			else
			{
				this.setNote( "<font style='color:red;'>Error: 执行续费失败[ "+data.msg+" ]</font>", 0 );
			}
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// custList.vue?715b423a